import { gql } from "@apollo/client";

export const GET_ALL_SPECIES = gql`
    query getAllSpecies {
      species(
        skip: 0
      ) {
        items {
          species {
            id,
            active,
            name,
          }
        }
      }
    }
  `;
